import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DesignModel } from '@app/shared/models/design';
import { InksoftService } from '@app/shared/services/inksoft/inksoft.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FilterModel, FilterList, ProductList, CategoryModel, SubCategoryModel } from '@app/shared/models/product';
import { ProductService } from '@app/shared/services/product/product.service';
import { MatDialog } from '@angular/material/dialog';
// import { PublishProductComponent } from '@app/shared/components/publish-product/publish-product.component';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DeleteCustomizedProduct } from '../../models/cart';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-saved-designs',
  templateUrl: './saved-designs.component.html',
  styleUrls: ['./saved-designs.component.css']
})
export class SavedDesignsComponent implements OnInit {

 // For Infinite scroll of grid
pageSize = 5; // No of items to load from server side i.e no of items to take
initialItemsCount !: number;  // No of items to skip
throttle = 50;
scrollDistance = 1;
searchString: any;
// -------------------------
searchCustomizedForm !: FormGroup;

  customizedProducts !: any[];
  designModel !: DesignModel;
  designId !: number;
  productId = localStorage.getItem('productIdToBeDesigned');
  styleId = localStorage.getItem('styleIdToBeDesigned');
  imgBaseURL = environment.imgBaseURL; // empty post Design Huddle migration; columns hold absolute blob URLs

   ApplicationUserId !: any;
   /** filtermodel holds filtering data to get filtered records from API */
   filterModel !: FilterModel;
   /** Filter list is for master filter list record */
   filterList !: FilterList ;
   publisherId = 11016;
   productsCount = 0;
   isDisableFilterBtn = true;
   categoryList: CategoryModel[] = [];
   subCategoryList: SubCategoryModel[] = [];
   catlist: any [] = [];
   @ViewChildren('brandCheckbox') private brandCheckboxes !: QueryList<any>;
   @ViewChildren('colorCheckbox') private colorCheckboxes !: QueryList<any>;
   @ViewChildren('sizeCheckbox')  private sizeCheckboxes !: QueryList<any>;
   inkSoftUserId: any;
   parentRouteParam!: any;
   deleteCustomizedProduct !: DeleteCustomizedProduct;

  constructor(private loader: LoaderService, private router: Router, private activatedRoute: ActivatedRoute,
    private inksoftService: InksoftService, private notification: NotificationService, private productService: ProductService,
    public dialog: MatDialog, private formBuilder: FormBuilder, private errorhandlerService: ErrorhandlerService) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.designId = params['designID']; // Design id in response by Inksoft
        this.customizedProducts = [];
        this.productsCount = 0;
      });

      this.searchCustomizedForm = this.formBuilder.group({
        searchProduct: ['']
      });

      if (this.activatedRoute.parent) {
        this.activatedRoute.parent.params.subscribe(params => {
          this.parentRouteParam = params['storename'];
        });
      }
    }

    ngOnInit() {
      this.inkSoftUserId = localStorage.getItem('inksoftUserId') !== null ? localStorage.getItem('inksoftUserId') : '';
      this.initialize();
      this.fn_GetCategories();
      this.fn_GetFilters();
      if (this.designId !== 0 && this.designId !== null && this.designId !== undefined) {
        this.fn_SaveDesign(this.designId);
      } else {
        this.fn_GetSavedDesignListing(true);
      }
    }

    initialize() {
      this.ApplicationUserId = localStorage.getItem('userId');
      this.customizedProducts = [];
       this.productsCount = 0;
      this.filterModel = {
        Skip: 0,
        Take: 8,
        Size: [],
        Brand: [],
        Color: [],
        InkSoftUserId: 0,
        searchBy: '',
        Category: ''
      };
      this.filterList = {
        Categories: [],
        Brands: [],
        Colors: [],
        Sizes: []
      };
      this.deleteCustomizedProduct = {
        DesignId: 0,
        ProductId: 0,
        StyleId: 0,
        UserId: 0
      };
    }

    fn_searchCustomizeProduct(form: FormGroup) {
        this.initialItemsCount = 0;
        this.searchString = form.controls['searchProduct'].value;
        this.fn_GetSavedDesignListing(true);
      }
    /** Get master filters data for product(s) */
    fn_GetFilters() {
      this.filterList.Brands = [];
      this.filterList.Colors = [];
      this.filterList.Sizes = [];
      this.productService.getCustomizedProductsMasterFiltersData().subscribe((res: any) => {
        if (res.Message === 'Success' || res.StatusCode === 200) {
          this.filterList.Brands = res.Data.FilterModel.Brands;
          this.filterList.Colors = res.Data.FilterModel.Colors;
          this.filterList.Sizes = res.Data.FilterModel.Sizes;
        }
      }, err => {
        // this.errorhandlerService.handleError(err);
      });
    }

    /** Modify filter model for selected brand */
    fn_SelectBrand(event: any, brandId: number) {
      if (this.filterModel.Brand.length > 0) {
        for (let i = 0; i < this.filterModel.Brand.length; i++) {
          if (this.filterModel.Brand[i] === brandId && !event.checked) {
            this.filterModel.Brand.splice(i, 1);
          }
        }
      }
      if (event.checked) {
        this.filterModel.Brand.push(brandId);
      }
      this.filterModel.Skip = 0;
      this.filterModel.Take = 8;
      this.filterModel.searchBy = '';
      this.fn_ResetProductList();
      this.fn_GetSavedDesignListing(true);
    }

    /** Modify filter model for selected color */
    fn_SelectColor(event: any, colorName: string) {
      if (this.filterModel.Color.length > 0) {
        for (let i = 0; i < this.filterModel.Color.length; i++) {
          if (this.filterModel.Color[i] === colorName && !event.checked) {
            this.filterModel.Color.splice(i, 1);
          }
        }
      }
      if (event.checked) {
        this.filterModel.Color.push(colorName);
      }
      this.filterModel.Skip = 0;
      this.filterModel.Take = 8;
      this.filterModel.searchBy = '';
      this.fn_ResetProductList();
      this.fn_GetSavedDesignListing(true);
    }

    /** Modify filter model for selected Size */
    fn_SelectSize(event: any, size: string) {
      if (this.filterModel.Size.length > 0) {
        for (let i = 0; i < this.filterModel.Size.length; i++) {
          if (this.filterModel.Size[i] === size && !event.checked) {
            this.filterModel.Size.splice(i, 1);
          }
        }
      }
      if (event.checked) {
        this.filterModel.Size.push(size);
      }
      this.filterModel.Skip = 0;
      this.filterModel.Take = 8;
      this.filterModel.searchBy = '';
      this.fn_ResetProductList();
      this.fn_GetSavedDesignListing(true);
    }

     /** Resets product list */
    fn_ResetProductList() {
      this.customizedProducts = [];
      this.productsCount = 0;
    }

    /** Enable/Disale(s) reset filter button */
    fn_EnableDisableResetFilterBtn() {
      if (this.filterModel.Size.length > 0 || this.filterModel.Brand.length > 0 || this.filterModel.Color.length > 0
         || this.filterModel.Category !== '')  {
        this.isDisableFilterBtn = false;
      } else {
        this.isDisableFilterBtn = true;
      }
    }

    /**Clears selected filters */
  fn_ClearFilter() {      
      this.filterModel.Skip = 0;
      this.filterModel.Take = 8;
      this.filterModel.Brand = [];
      this.filterModel.Color = [];
      this.filterModel.Size = [];
      this.filterModel.searchBy = '';
      this.filterModel.Category = '';
      this.fn_ResetProductList();
      this.fn_EnableDisableResetFilterBtn();
      this.fn_GetSavedDesignListing(true);
      this.fn_UncheckFilterCheckboxes();
      // this.getFilters();
    }

    /** Function to uncheck all the filter(s) */
    fn_UncheckFilterCheckboxes() {
      this.brandCheckboxes.toArray().forEach(element => {
        element.checked = false;
      });

      this.colorCheckboxes.toArray().forEach(element => {
        element.checked = false;
      });

      this.sizeCheckboxes.toArray().forEach(element => {
        element.checked = false;
      });
    }

    /** Function to save newly customized product to database */
    fn_SaveDesign(designId: number) {
      this.designModel = {
          DesignId: +designId,
          ProductId: this.productId !== null ? +this.productId : 0,
          StyleId: this.styleId !== null ? + this.styleId : 0,
          ApplicationUserId: localStorage.getItem('userId'),
          IsEmbroideryType:false,
          CopiedDesignId: null
      };

      this.loader.show();
      this.inksoftService.saveCustomizedDesign(this.designModel).subscribe((res: any) => {
        if (res.Message === 'Success' || res.StatusCode === 200) {
          this.notification.success('Product customized successfully', 'Customization');
          this.fn_ResetProductList();
          this.router.navigate([this.parentRouteParam + '/saveddesigns']);
          this.fn_GetSavedDesignListing(true);
          this.loader.hide();
        } else if (res.StatusCode === 400) {
          this.notification.error('An error occured. Try again', 'Error');
          this.loader.hide();
        } else {
          this.notification.error('An error occured. Try again', 'Error');
          this.loader.hide();
        }
      }, err => {
        // this.notification.error('Internal server error. Try again', 'Error');
        this.errorhandlerService.handleError(err);
        this.loader.hide();
      });
    }

    /** Function to GET list of customized product(s)*/
    fn_GetSavedDesignListing(status: boolean) {
      // this.customizedProducts = [];
      // this.productsCount = 0;
      this.fn_EnableDisableResetFilterBtn();
     // this.loader.show();
     if (!status) {
      this.loader.hide();
      this.loader.lazyLoaderShow();
    }  else  {
      this.loader.show();
      this.loader.lazyLoaderHide();
    }
      this.filterModel.Skip = this.productsCount;
      this.filterModel.searchBy = (this.fn_CheckForNullUndefinedEmptyString(this.searchString));
      this.filterModel.InkSoftUserId = this.inkSoftUserId;
      this.inksoftService.getCustomizedProductsList(this.filterModel).subscribe((res: any) => {
        if (res.StatusCode === 200 && res.Message === 'Success') {
          if (res.Data.ResponseData.length > 0 && res.Data.ResponseData !== null) {
            res.Data.ResponseData.forEach((obj: any) => {
              // check if item with same id exists
              if (!this.customizedProducts.find(x => x.CustomizedProductId === obj.CustomizedProductId)) {
                this.productsCount = this.customizedProducts.push(obj);
              }
            });
          }
          // this.loader.hide();
          if (!status) {
            this.loader.lazyLoaderHide();
          }  else  {
            this.loader.hide();
          }
        } else {
          this.notification.error('Internal server error. Try again', 'Error');
         // this.loader.hide();
         if (!status) {
          this.loader.lazyLoaderHide();
        }  else  {
          this.loader.hide();
        }
        }
      }, err => {
        // this.notification.error('Internal server error. Try again', 'Error');
        // this.loader.hide();
        this.errorhandlerService.handleError(err);
        if (!status) {
          this.loader.lazyLoaderHide();
        }  else  {
          this.loader.hide();
        }
      });
    }
     /** delete customized product */
    fn_deleteCustomizedProduct(CustomizedProductId: any, DesignId: any, StyleId: any, ProductId: any) {
      this.deleteCustomizedProduct.DesignId = DesignId;
      this.deleteCustomizedProduct.StyleId = StyleId;
      this.deleteCustomizedProduct.ProductId = ProductId;
      this.deleteCustomizedProduct.UserId = this.ApplicationUserId;
      this.inksoftService.deleteCustomizedProduct(this.deleteCustomizedProduct).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.notification.success(res.Message, 'Suceess');
          this.fn_ClearFilter();
          this.loader.hide();
        } else {
          this.notification.error('Internal server error. Try again', 'Error');
          this.loader.hide();
        }
      }, err => {
        // this.notification.error('Internal server error. Try again', 'Error');
        this.errorhandlerService.handleError(err);
        this.loader.hide();
      });
    }

    /** Function to add new lazy loaded items to original items list */
    fn_AddLazyLoadedItems (items: any) {
      if (items !== null) {
      if (items.length !== 0) {
        for (let i = 0; i < items.length; i++) {
            this.initialItemsCount = this.customizedProducts.push(items[i]);
        }
      }
      }
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }

  /** Get product categories & sub-categories */
  fn_GetCategories() {
    this.productService.getProductCategoyAndSubCategory().subscribe(res => {
      if (res.StatusCode === 200) {
        if (res.Data.ResponseData.length > 0) {
          this.catlist = res.Data.ResponseData;
          for (let i = 0; i < res.Data.ResponseData.length; i++) {
            this.categoryList.push({
              CategoryId: Number(res.Data.ResponseData[i].ID),
              CategoryName: res.Data.ResponseData[i].Name,
              SubCategoryCount: res.Data.ResponseData[i].SubCategories.length
            });
            if (res.Data.ResponseData[i].SubCategories.length > 0) {
              for (let j = 0; j < res.Data.ResponseData[i].SubCategories.length; j++) {
                this.subCategoryList.push({
                  ParentCategoryId: Number(res.Data.ResponseData[i].ID),
                  SubCategoryId: Number(res.Data.ResponseData[i].SubCategories[j].ID),
                  SubCategoryName: res.Data.ResponseData[i].SubCategories[j].Name
                });
              }
            }
          }
        }
      }
    }, (err: any) => {
      // this.errorhandlerService.handleError(err);
    });
  }

  /** Function set selected category in filter model */
  fn_SelectCategory(categoryId: string) {
    this.filterModel.Category = '';
    this.fn_ResetProductList();
    this.fn_UncheckFilterCheckboxes();
    this.fn_EnableDisableResetFilterBtn();
    this.filterModel.Category = categoryId;
    this.filterModel.Skip = 0;
    this.filterModel.Take = 8;
    this.filterModel.searchBy = '';
    this.filterModel.Brand = [];
    this.filterModel.Color = [];
    this.filterModel.Size = [];
    this.fn_GetSavedDesignListing(true);
  }

}
